import { selectModuleConfiguration } from 'src/store/selectors/configurations';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
export var MainReportApiVersion;
(function (MainReportApiVersion) {
    MainReportApiVersion[MainReportApiVersion["None"] = 0] = "None";
    MainReportApiVersion[MainReportApiVersion["V1"] = 1] = "V1";
    MainReportApiVersion[MainReportApiVersion["V2"] = 2] = "V2";
    MainReportApiVersion[MainReportApiVersion["Both"] = 3] = "Both";
})(MainReportApiVersion || (MainReportApiVersion = {}));
export default function useMainReportApiVersion() {
    const mainReportConfig = useSelector((state) => selectModuleConfiguration(state, 'MainReport'));
    function getMainReportApiVersion(period) {
        const [from, to] = period;
        const { StartNewMainReportMonth } = mainReportConfig;
        const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
        if (!newReportMigrationMonth)
            return MainReportApiVersion.V1;
        if (from.isSameOrAfter(newReportMigrationMonth)) {
            return MainReportApiVersion.V2;
        }
        if (to.isBefore(newReportMigrationMonth)) {
            return MainReportApiVersion.V1;
        }
        return MainReportApiVersion.Both;
    }
    return {
        getMainReportApiVersion
    };
}
